import ProductsPage from '../pages/Products.page';
import ProductPage from '../pages/Product.page';
import ClinicoPage from '../pages/Clinico.page';
import HrmPage from '../pages/Hrm.page';
import FinancialManagementPage from '../pages/FinancialManagement.page';
import CrmPage from '../pages/Crm.page';
import CrmEms from '../pages/CrmEms.page';
import CrmGms from '../pages/CrmGms.page';
import CrmHms from '../pages/CrmHms.page';
import CrmRms from '../pages/CrmRms.page';

const ProductsRoutes = [
    {
        path: '/products',
        children: [
            { index: true, element: <ProductsPage />, layout: 'default', isAuthReq: true },
            {
                path: ':slug',
                element: <ProductPage />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
    {
        path: '/clinico',
        children: [{ index: true, element: <ClinicoPage />, layout: 'default', isAuthReq: true }],
    },
    {
        path: '/hr-management',
        children: [{ index: true, element: <HrmPage />, layout: 'default', isAuthReq: true }],
    },
    {
        path: '/financial-management',
        children: [{ index: true, element: <FinancialManagementPage />, layout: 'default', isAuthReq: true }],
    },
    {
        path: '/crm',
        children: [
            {
                index: true,
                element: <CrmPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'ems',
                element: <CrmEms />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'gms',
                element: <CrmGms />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'hms',
                element: <CrmHms />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'rms',
                element: <CrmRms />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
];

export { ProductsRoutes };
